const SCROLL_END_OFFSET = 1;

export const isShowTabsShadow = (scrollableElem: HTMLElement | null): boolean => {
  if (!scrollableElem) return false;
  const { scrollWidth, scrollLeft } = scrollableElem;
  const { width } = scrollableElem.getBoundingClientRect();
  return scrollLeft <= scrollWidth - width - SCROLL_END_OFFSET;
};
